module.exports = __webpack_public_path__ + "img/searchbg.52b527e7.png";